export function disabledArea(dom: string | HTMLElement, flag: boolean): void {
	let nodes: NodeListOf<Element> | undefined

	if (typeof dom === 'string') {
		const element = document.getElementById(dom)
		if (!element) return
		nodes = element.querySelectorAll('.to-disable-target')
	} else if (dom instanceof HTMLElement) {
		nodes = dom.querySelectorAll('.to-disable-target')
	} else {
		return
	}

	if (!nodes || nodes.length === 0) return

	for (let i = 0; i < nodes.length; i++) {
		const node = nodes[i] as Element

		// 尝试通过 Vue 3 的方式获取组件实例
		if ('__vueParentComponent' in node) {
			const componentInstance = (node as any).__vueParentComponent
			if (componentInstance && typeof componentInstance.exposed?.setDisabled === 'function') {
				componentInstance.exposed.setDisabled(!!flag)
			}
		}
		// 如果是 Vue 组件挂载的根元素，可以通过 ref 访问
		else if (node instanceof HTMLElement) {
			// 查找组件实例（如果通过 ref 挂载）
			const vueInstance = (node as any)._vnode?.ctx
			if (vueInstance && typeof vueInstance.exposed?.setDisabled === 'function') {
				vueInstance.exposed.setDisabled(!!flag)
			}
		}
	}
}

// 兼容默认导出
export default disabledArea
